import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    notifications: [],
};

const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        addNotification: (state, action) => {
            state.notifications.push({...action.payload, isRead: false});
        },
        setNotifications: (state, action) => {
            state.notifications = action.payload.map(notification => ({
                ...notification,
                isRead: notification.isRead || false,
            }));
        },
        markAsRead: (state, action) => {
            const index = state.notifications.findIndex(n => n.id === action.payload);
            if (index !== -1) {
                state.notifications[index].isRead = true;
            }
        },
    },
});

export const {addNotification, setNotifications, markAsRead} = notificationSlice.actions;

export default notificationSlice.reducer;
